module.exports = __webpack_public_path__ + "img/chufangliang.007f8096.png";